module.exports = __webpack_public_path__ + "assets/img/logo.0f80da2d.png";